module.exports = __webpack_public_path__ + "img/about-9.acdb9ee0.jpg";